const defaultState = {};

export default function workspacePrivateNote(state = defaultState, action) {
  switch (action.type) {
    case 'GET_WORKSPACE_PRIVATE_NOTE_RESPONSE':
      return action.payload.workspacePrivateNote;
    case 'UPDATE_WORKSPACE_PRIVATE_NOTE_RESPONSE':
      return { ...state, ...action.payload.workspacePrivateNote };
    case 'CLEAR_WORKSPACE_PRIVATE_NOTE':
      return defaultState;
    default:
      return state;
  }
}
